import React from 'react';
import {TRecord, TText} from '@packages/systems/wfdl-ast';
import {
  type ContextualExpression,
  stripAll,
} from '@packages/utilities/contextual-expression';
import {
  withSystem,
  Expressions,
  TypeImplementation,
  Plugins,
} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';

const type = TRecord({
  t: withSystem(
    {defaultValue: 'Another option', label: 'Text', isLocalizable: true},
    TText
  ),
  v: withSystem(
    {defaultValue: 'Another option', label: 'Value', isLocalizable: true},
    TText
  ),
});

const FormSelectOption = TypeImplementation.Alias({
  type,
  renderSummary: ({expr}: {expr: ContextualExpression}) => {
    const strippedExpr = stripAll(expr);

    const optionRecord = Expressions.getRecord(strippedExpr);
    if (optionRecord === null) {
      throw Error('Failed to get Record from strippedExpr');
    }
    const {t} = optionRecord;

    if (t === undefined) {
      throw Error('Property "t" of optionRecord is undefined');
    }

    return <span>{Expressions.getText(t)}</span>;
  },
  icon: TypeImplementation.IconByName(
    qualify(Plugins.name('Form'), iconName('Radio'))
  ),
  render: function FormSelectOptionRender({expr, dispatch}) {
    return <ExpressionEditor expression={expr} dispatch={dispatch} />;
  },
});

export default FormSelectOption;
